/**
 * Dispatch Asset / autobattler battles use game ids containing `_autobattler_`.
 * They must not use the Friends "spectating" session path (sessionStorage + context),
 * or a stale friend-spectate flag causes a blank battle until full reload.
 */

export function isDispatchAutobattlerGameId(gameId) {
  return Boolean(gameId && String(gameId).includes('_autobattler_'));
}

/**
 * True only when the user is actively friend-spectating (Friends WS), not dispatch autobattler.
 * @param {boolean} isSpectatingFromContext - `useFriends().isSpectating`
 * @param {string|undefined|null} gameId - URL session game id
 */
export function isFriendSpectatingSession(isSpectatingFromContext, gameId) {
  return Boolean(isSpectatingFromContext) && !isDispatchAutobattlerGameId(gameId);
}
